<template>
  <v-card class="pa-1 mb-1 primary darken-2">
    <v-card-title class="text-title">
      <v-icon v-if="showTooltip.icon_params" class="pa-1 mr-1" size="12" color="white"
          :style="`border-radius: 50%;background-color: ${showTooltip.icon_params.background_color}`">{{
            showTooltip.icon_params.class }}
      </v-icon>{{ showTooltip.value_title }}
    </v-card-title>
    <v-card-subtitle class="text-subtitle">
      {{ showTooltip.value_subtitle }}
    </v-card-subtitle>

    <v-card-text>
      <v-row dense v-for="(item, i) in showTooltip.items" :key="i">
        <v-col cols="6" sm="6">
          <span class="text-item">{{ item.label }}</span>
        </v-col>
        <v-col v-if="item.value_function" cols="6" sm="6">
          <div class="d-flex">
            <v-icon :color="getReturnFunction(item.value_function, item.value).color" size="20px">
            {{ item.icon_label != '' ? item.icon_label : 'fiber_manual_record' }}
            </v-icon>
              <strong class="text-value pt-0 pl-3">
                {{ getReturnFunction(item.value_function, item.value).name }}
              </strong>
          </div>
        </v-col>
        <v-col v-else cols="6" sm="6">
          <div class="d-flex">
            <strong>{{ item.value }}</strong>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TooltipWaterAvailability",
  props: ["tooltipParams", "showTooltip"],
  data: () => ({}),
  methods: {
    getReturnFunction(functionName, value) {
      let newValue = value;
      newValue = eval(`this.${functionName}(value)`);
      return newValue;
    },
    getNameAndColorWaterAvailability(status) {
      status = status.toLowerCase();
      if (status == "estiagem") {
        return {
          color: 'rgb(252, 66, 74)',
          name: 'Estiagem'
        }
      }
      else if (status == "rio baixo") {
        return {
          color: 'rgb(255, 171, 0)',
          name: 'Rio baixo'
        }
      }
      else if (status == "rio normal") {
        return {
          color: 'rgb(0, 144, 231)',
          name: 'Normal'
        }
      }
      else if (status == "rio alto") {
        return {
          color: 'rgb(0, 210, 91)',
          name: 'Rio alto'
        }
      }
      else if (status == "cheia") {
        return {
          color: 'rgb(143, 95, 232)',
          name: 'Cheia'
        }
      }

      return {
        color: '#D9D9D9',
        name: 'Sem Dados'
      }
    }
  }
};
</script>

<style scoped>
.text-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
}

.text-subtitle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 15px;
  color: #ffffff;
  padding-top: 2px;
}

.text-item {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  left: 22px;
}

.text-value {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
}
</style>